import * as Sentry from '@sentry/react';
import { ReactNode } from 'react';

import { ErrorDistributor } from './common/Error/ErrorDistributor';

interface ErrorBoundaryProps {
    children: ReactNode;
}

export const ErrorBoundary = ({ children }: ErrorBoundaryProps) => {
    return (
        <Sentry.ErrorBoundary
            fallback={({ error, componentStack, resetError }) => {
                return <ErrorDistributor error={error} stack={componentStack} resetError={resetError} />;
            }}
        >
            {children}
        </Sentry.ErrorBoundary>
    );
};
